import React from 'react'
import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './agenda-en-media.css'

const AgendaEnMedia = (props) => {
  return (
    <div className="agenda-en-media-container">
      <Helmet>
        <title>Agenda en Media - Schrijf je vrij</title>
        <meta
          property="og:title"
          content="Agenda en Media - Schrijf je vrij"
        />
        <meta
          name="description"
          content="Agenda en media voor lezingen, activiteiten en publicaties"
        />
      </Helmet>
      <div className="agenda-en-media-top-container">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name27" />
      </div>
      <main className="agenda-en-media-main">
        <section className="agenda-en-media-section">
          <div className="agenda-en-media-section-header">
            <h2>Agenda</h2>
          </div>

          <div className="agenda-en-media-media-grid agenda-en-media-media-grid-single">
            <a href="https://www.deboekpub.nl/noordergloed-2/" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/Boekpub.png"
                  alt="Lezing in de Boekpub"
                  className="agenda-en-media-media-image agenda-en-media-boekpub-image"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>20 juni 2026, 13.30 uur</em>
                  <span>Lezing in de Boekpub tijdens festival Noordergloed in Veenhuizen</span>
                </h3>
              </div>
            </a>
          </div>
        </section>

        <section className="agenda-en-media-section">
          <div className="agenda-en-media-section-header">
            <h2>Media</h2>
          </div>

          <div className="agenda-en-media-media-grid">
            <a href="https://slotstad.nl/radio/gemist/boekenradio/e447fa66-85d0-4c1a-8a5a-e298dd874add/boekenradio-02-mei-2026-vanaf-1000uur" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/BoekenRadio.png"
                  alt="BoekEnRadio interview"
                  className="agenda-en-media-media-image"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>2 mei 2026, 10.00 uur</em>
                  <span className="agenda-en-media-nowrap">Interview door BoekEnRadio,</span>
                  <span>Slotstadrtv Zeist</span>
                </h3>
              </div>
            </a>

            <a href="https://nationaleziekenomroep.com/boekbespreking-295-april-2026-week-17/" target="_blank" rel="noreferrer" className="agenda-en-media-media-card agenda-en-media-dailycard">
              <div className="agenda-en-media-media-image-wrapper agenda-en-media-daily-image-wrapper">
                <img
                  src="/Blog foto's/DailyChannel.png"
                  alt="DailyChannel"
                  className="agenda-en-media-media-image"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>Vanaf 22 april 2026</em>
                  <span>Ingesproken samenvatting boek te beluisteren op dailychannel.fm (deel 2, vanaf 18m14s)</span>
                </h3>
              </div>
            </a>

            <a href="https://www.youtube.com/watch?v=1Jf50AZViQU" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/Couleur Locale.png"
                  alt="Couleur Locale"
                  className="agenda-en-media-media-image agenda-en-media-media-image-small"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>1 april 2026</em>
                  <span>Televisie-interview bij Couleur Locale</span>
                </h3>
              </div>
            </a>

            <a href="https://www.castricummer.nl/lokaal/kunst/125404/marjan-gerrits-uit-castricum-op-nominatielijst-literatuurprijzen" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/nominatie Castricum.png"
                  alt="Nominatie Castricum"
                  className="agenda-en-media-media-image agenda-en-media-media-image-small"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>7 maart 2026</em>
                  <span>Krantenartikel in de Castricummer naar aanleiding van nominatie voor de Literaire Parel</span>
                </h3>
              </div>
            </a>

            <a href="https://www.denieuwsbode.nl/lokaal/achtergrond/1255949/valt-verhaal-over-zeistenaar-in-de-prijzen-" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/nominatie.png"
                  alt="Nominatie Nieuwsbode"
                  className="agenda-en-media-media-image agenda-en-media-media-image-small"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>5 maart 2026</em>
                  <span>Krantenartikel in de Nieuwsbode naar aanleiding van nominatie voor de Literaire Parel</span>
                </h3>
              </div>
            </a>

            <a href="https://www.noordhollandsdagblad.nl/regio/ijmond/boek-van-bakkumse-over-nederlandse-vader-en-duitse-schoonvader-in-tweede-wereldoorlog-maakt-kans-op-literaire-prijs/137712057.html" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/nominatie Bakkumse.png"
                  alt="Nominatie Bakkumse"
                  className="agenda-en-media-media-image agenda-en-media-media-image-small"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>1 maart 2026</em>
                  <span>Krantenartikel in het Noordhollands Dagblad naar aanleiding van nominatie voor de Literaire Parel</span>
                </h3>
              </div>
            </a>

            <a href="https://slotstad.nl/radio/gemist/slotstad-magazine/4883a99b-bf8e-46cc-8ef8-67f9834eff7b/slotstad-magazine-3-mei-2025-van-1200uur" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/Slotstad Radio.png"
                  alt="Slotstad Radio"
                  className="agenda-en-media-media-image agenda-en-media-media-image-small"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>3 mei 2025</em>
                  <span>Radio-interview door Slotstad Magazine Zeist (start in de 6e minuut)</span>
                </h3>
              </div>
            </a>

            <a href="https://www.castricummer.nl/nieuws/winkels/118551/marjan-gerrits-te-gast-bij-boekhandel-laan" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/Lezing Laan.png"
                  alt="Lezing Laan"
                  className="agenda-en-media-media-image agenda-en-media-media-image-small"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>29 april 2025</em>
                  <span>Lezing bij Boekhandel Laan in Castricum</span>
                </h3>
              </div>
            </a>

            <a href="https://www.denieuwsbode.nl/lokaal/achtergrond/1161149/boek-en-lezing-over-zeister-oorlogsverhaal-twee-kanten-van-ee" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/Lezing Zeist.png"
                  alt="Lezing Zeist"
                  className="agenda-en-media-media-image agenda-en-media-media-image-small"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>27 april 2025</em>
                  <span>Lezing bij het TorenlaanTheater in Zeist</span>
                </h3>
              </div>
            </a>

            <a href="https://www.schrijversacademie.nl/over-schrijversacademie/blogs/marjan-gerrits/" className="agenda-en-media-media-card">
              <div className="agenda-en-media-media-image-wrapper">
                <img
                  src="/Blog foto's/Schrijversacademie.png"
                  alt="Schrijversacademie"
                  className="agenda-en-media-media-image agenda-en-media-media-image-small"
                />
              </div>
              <div className="agenda-en-media-media-body">
                <h3>
                  <em>mei 2025</em>
                  <span>Wall of Fame Schrijversacademie</span>
                </h3>
              </div>
            </a>
          </div>
        </section>
      </main>
      <Footer rootClassName="footerroot-class-name27" />
    </div>
  )
}

export default AgendaEnMedia
